import type { Platform } from "@/types"

export function mentionLabelsInBody(body: string): string[] {
  const tokens = body.match(/@(\w+)/g) ?? []
  return [...new Set(tokens.map((t) => t.slice(1)))]
}

export function handleValidationState(platform: Platform, handle: string) {
  const normalizedHandle = handle.trim()
  const pattern = platform.mention_handle_pattern

  if (!normalizedHandle || !pattern) return null

  return new RegExp(pattern).test(normalizedHandle)
    ? { valid: true as const }
    : { valid: false as const, message: platform.mention_handle_error_message }
}
